import { EndType } from '@wix/ambassador-pricing-plans-v3-plan/types';

/**
 * @returns true if plan is one time only
 */
export const isOneTimePricingVariant = variant => {
  const billingTerms = variant.billingTerms;
  if ((billingTerms == null ? void 0 : billingTerms.endType) === EndType.UNTIL_CANCELLED) {
    return !(billingTerms != null && billingTerms.billingCycle);
  }
  if ((billingTerms == null ? void 0 : billingTerms.endType) === EndType.CYCLES_COMPLETED) {
    var _billingTerms$cyclesC;
    return (billingTerms == null || (_billingTerms$cyclesC = billingTerms.cyclesCompletedDetails) == null ? void 0 : _billingTerms$cyclesC.billingCycleCount) === '1';
  }
  return false;
};
//# sourceMappingURL=is-one-time-pricing-variant.js.map